<div id="manual-adjustment-dialog">
  <h2 mat-dialog-title>Discount Details</h2>
  <div mat-dialog-content>
    <p>ScoreCard Rewards {{amount | currency }} Off</p>
    <li>Please refer to your ScoreCard Rewards Certificate for its expiration date.</li>
    <li>Excludes Beats by Dre and Polo Sport products. Additional exclusions may apply.</li>
    <p>1) ScoreCard Rewards are redeemable at DICK'S Sporting Goods stores and at Dicks.com.</p>
    <P>2) ScoreCard Rewards can only be used once and are invalid after the slated expiration date.</P>
    <p>3) Cash or store credit will not be given for unused portion of the ScoreCard Rewards.</p>
    <p>4) ScoreCard Rewards have no cash value.</p> 
    <p>5) Sales tax, prior purchases, Gift Cards, eGift Cards, extended warranties, licenses, online services and service items are excluded.</p>
    <p>6) Some additional exclusions may apply. See store or website for details. </p>
    
    <h3>RETURNS</h3>
    <p>Merchandise purchased with ScoreCard Rewards may be exchanged for merchandise only. Returns or exchanges where Scorecard Rewards or other discounts were applied may result in an adjusted refund amount.</p> 
    
    <h3>ONLINE REDEMPTION</h3>
    <p>Enter your ScoreCard Rewards number on the payment page during checkout.</p>
  </div>
</div>

